var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeBluePickup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16876 0H9.28585V5.71429H1.42871L3.89101 0.789695C4.13299 0.305718 4.62766 0 5.16876 0Z",
    fill: "#2F80ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5716 5.71429H10.7144V0H14.8315C15.3726 0 15.8673 0.305717 16.1093 0.789694L18.5716 5.71429Z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42871 7.14286H18.5716V18.5714C18.5716 19.3604 17.932 20 17.143 20H2.85728C2.0683 20 1.42871 19.3604 1.42871 18.5714V7.14286ZM8.143 12.1429C8.143 11.5906 7.69528 11.1429 7.143 11.1429C6.59071 11.1429 6.143 11.5906 6.143 12.1429V15C6.143 15.5523 6.59071 16 7.143 16C7.69528 16 8.143 15.5523 8.143 15V12.1429ZM13.8573 12.1429C13.8573 11.5906 13.4096 11.1429 12.8573 11.1429C12.305 11.1429 11.8573 11.5906 11.8573 12.1429V15C11.8573 15.5523 12.305 16 12.8573 16C13.4096 16 13.8573 15.5523 13.8573 15V12.1429Z",
    fill: "#2F80ED"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeBluePickup);
export default __webpack_public_path__ + "static/media/time_blue_pickup.12a160b4.svg";
export { ForwardRef as ReactComponent };